module.exports = __webpack_public_path__ + "static/media/about-2.c44e3045.svg";